import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Ссылка на конкретный комментарий адресует "{cardId}~comment-{id}" —
 * открывает свою модалку, если хэш указывает на комментарий именно у этой
 * карточки/проблемы/решения.
 */
export const useOpenModalOnCommentHash = (
  cardId: string,
  showComments: boolean,
  setIsModalOpen: (isOpen: boolean) => void,
) => {
  const location = useLocation();

  useEffect(() => {
    if (!showComments) return;

    const hash = location.hash.slice(1);

    if (hash.startsWith(`${cardId}~comment-`)) {
      setIsModalOpen(true);
    }
  }, [location.hash, cardId, showComments, setIsModalOpen]);
};
